import moment from 'moment'
import Person from './Person'

class PhysicalPerson extends Person {
    constructor(
        id,
        type,
        name,
        lastName,
        displayName,
        email,
        birthday,
        age,
        identityNumber,
        singleTaxIdentification,
        gender,
        phoneType,
        phoneNumber,
        streetName,
        streetNumber,
        flat,
        floor,
        locality,
        interactions,
        countMultiQuotes,
        countPolicies,
        broker,
        sellerName,
        notes,
        hasLoan,
        loanNumber,
        loanExpirationDate,
    ) {
        super(
            id,
            type,
            locality,
            displayName,
            email,
            phoneType,
            phoneNumber,
            countMultiQuotes,
            countPolicies,
        )

        this.firstName = name
        this.name = name
        this.lastName = lastName
        this.email = email
        this.birthday = birthday ? moment(birthday) : null
        this.age = age
        this.dni = identityNumber
        this.cuil = singleTaxIdentification
        this.gender = gender
        this.streetName = streetName
        this.streetNumber = streetNumber
        this.flat = flat
        this.floor = floor
        this.interactions = interactions
        this.broker = broker
        this.sellerName = sellerName
        this.notes = notes
        this.hasLoan = hasLoan
        this.loanNumber = loanNumber
        this.loanExpirationDate = loanExpirationDate
    }

    getFullName() {
        return `${this.firstName} ${this.lastName}`
    }

    static fromJson({
        id,
        type,
        name,
        lastName,
        displayName,
        email,
        birthday,
        age,
        identityNumber,
        singleTaxIdentification,
        gender,
        phoneType,
        phoneNumber,
        streetName,
        streetNumber,
        flat,
        floor,
        locality,
        interactions,
        countMultiQuotes,
        countPolicies,
        broker,
        sellerName,
        notes,
        hasLoan,
        loanNumber,
        loanExpirationDate,
    }) {
        return new PhysicalPerson(
            id,
            type,
            name,
            lastName,
            displayName,
            email,
            birthday,
            age,
            identityNumber,
            singleTaxIdentification,
            gender,
            phoneType,
            phoneNumber,
            streetName,
            streetNumber,
            flat,
            floor,
            locality,
            interactions,
            countMultiQuotes,
            countPolicies,
            broker,
            sellerName,
            notes,
            hasLoan,
            loanNumber,
            loanExpirationDate,
        )
    }
}

export default PhysicalPerson
